import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import ReactSelect from "react-select";
import { toast } from "react-toastify";
import {
  getCategories,
  getCitiesByState,
  getLocalityByState,
  getmarketsByState,
  getSingleOffer,
  getStates,
  getUnits,
} from "../api";
import { api_url } from "../constant";
import Client from "../utils/client";
import AppBar from "./appBar";
import ReactGA from "react-ga4";
import { Header } from "./addform/Header";
import { Footer } from "./addform/Footer";
import { SelectInput } from "./addform/SelectInput";
import { useTranslation } from "react-i18next";

function Addform({ type, isEdit = false }) {
  const { t } = useTranslation();
  if (type === "sell") {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      title: "Add Crop Offer",
    });
  } else {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      title: "Add Crop Order",
    });
  }
  const [val, setVal] = useState("");
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    watch,
    reset,
  } = useForm();

  const [first, setFirst] = useState();
  const [images, setImages] = useState([]);
  const [media, setMedia] = useState([]);
  const navigate = useNavigate();
  let { id } = useParams();

  const { data: subCategories } = useQuery({
    queryKey: ["categories"],
    queryFn: () => getCategories(),
    initialData: [],
  });

  const { data: states } = useQuery({
    queryKey: ["states"],
    queryFn: () => getStates(),
    initialData: [],
  });

  const { data: cities, refetch: citiesRefetch } = useQuery({
    queryKey: ["cities"],
    queryFn: () => getCitiesByState(getValues().state.value),
    initialData: [],
    enabled: false,
  });

  const { data: markets, refetch: marketRefetch } = useQuery({
    queryKey: ["markets"],
    queryFn: () => getmarketsByState(getValues().state.value),
    initialData: [],
    enabled: false,
  });

  const { data: locality, refetch: localityRefetch } = useQuery({
    queryKey: ["locality"],
    queryFn: () => getLocalityByState(getValues().state.value),
    initialData: [],
    enabled: false,
  });

  const { data: units } = useQuery({
    queryKey: ["units"],
    queryFn: () => getUnits(),
    cacheTime: 99999,
    staleTime: 99999,
  });

  const { } = useQuery({
    queryKey: ["offer"],
    queryFn: () => getSingleOffer(id),
    enabled: isEdit,
    onSuccess: (data) => {
      reset({
        state: { label: data._state.name, value: data._state.id },
        //city: { label: data._city.name, value: data._city.id },
        locality: data._locality
          ? { label: data._locality?.name, value: data._locality?.id }
          : null,
        market: data._market
          ? { label: data._market?.name, value: data._market?.id }
          : null,
        offer: data.offer,
        category_id: 1,
        quantity: data.quantity.toString(),
        subCategory_id: {
          label: data.subCategory.name,
          value: data.subCategory.id,
        },
        unit: { label: data._unit.name, value: data._unit.id },
        price_per_unit: data.price_per_unit,
      });
    },
  });

  const onSubmit = (data) => post(data);
  const post = async (data) => {
    if (!data.offer) {
      // toast("يرجى كتابة وصف المحصول", { type: "error" });
      toast(t("addform.errors.noDescription"), { type: "error" });
      return;
    }
    if (!data.subCategory_id || !data.subCategory_id.value) {
      toast(t("addform.errors.noCrop"), { type: "error" });
      return;
    }
    if (!data.state || !data.state.value) {
      toast(t("addform.errors.noState"), { type: "error" });
      return;
    }
    if (!data.locality || !data.locality.value) {
      toast(t("addform.errors.noLocality"), { type: "error" });
      return;
    }
    if (!data.quantity || data.quantity <= 0) {
      toast(t("addform.errors.noQuantity"), { type: "error" });
      return;
    }
    const _data = JSON.stringify({
      category_id: 1,
      quantity: data.quantity.toString(),
      offer: data.offer,
      subCategory_id: data.subCategory_id?.value,
      locality: data.locality ? data.locality?.value.toString() : null,
      // city: data.city.value.toString(),
      market: data.market?.value.toString() || null,
      state: data.state.value.toString(),
      unit: data.unit.value.toString(),
      price_per_unit: data.price_per_unit,
      offer_type: type,
      currency: data.currency,
    });

    try {
      let response;
      if (isEdit) {
        response = await Client.post(api_url + `/offers/edit/${id}`, _data, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });
      } else {
        response = await Client.post(api_url + "/offers", _data, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });
      }

      // Check if the offer was created/updated successfully
      if (response.data && response.data.id) {
        const offerId = response.data.id; // Get the offer ID from the response

        // Upload images if any
        if (images.length > 0) {
          await uploadFiles(offerId);
        }

        // Redirect or show success message
        // toast("تم إنشاء العرض بنجاح", { type: "success" });
        toast(t("addform.success.offerCreated"), { type: "success" });
        window.history.go(-1); // Navigate back
      } else {
        // throw new Error("فشل في إنشاء العرض");
        throw new Error(t("addform.errors.offerCreationFailed"));
      }
    } catch (error) {
      console.error("Error:", error);
      toast(t("addform.errors.checkData"), { type: "error" });
    }
  };

  const uploadFiles = async (offerId) => {
    const formData = new FormData();
    images.forEach((image, index) => {
      formData.append("images", image);
    });

    // Log FormData contents
    for (let [key, value] of formData.entries()) {
      console.log(key, value);
    }

    try {
      const response = await fetch(`${api_url}/files/upload-images/offer/${offerId}`, {
        method: "POST",
        body: formData,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      const result = await response.json();

      if (response.status > 201) {
        throw new Error(result.message || "فشل في تحميل الصور");
      }

      // toast("تم تحميل الصور بنجاح", { type: "success" });
      toast(t("addform.success.imagesUploaded"), { type: "success" });
    } catch (error) {
      console.error("Error uploading files:", error);
      console.error("Images:", images);
      toast(t("addform.errors.uploadFailed"), { type: "error" });
    }
  };

  const sold = async () => {
    await Client.post(
      api_url + `/offers/edit/${id}`,
      JSON.stringify({ status: "sold" }),
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      }
    )
      .then((res) => window.history.go(-1))
      .catch((e) => toast(t("addform.errors.checkData"), { type: "error" }));
  };
  // Handle file upload
  const handleImageUpload = (file) => {
    if (file) {
      // Check file size (10 MB limit)
      const maxSizeMB = 10;
      if (file.size > maxSizeMB * 1024 * 1024) {
        // toast.error(`حجم الملف يتجاوز ${maxSizeMB} ميجابايت`);
        toast.error(t("addform.errors.fileTooBig", { maxSize: maxSizeMB }));
        return;
      }

      // Check number of files (maximum of 5)
      if (images.length >= 5) {
        // toast.error("يمكنك تحميل حتى 5 ملفات فقط");
        toast.error(t("addform.errors.maxFiles"));
        return;
      }

      setImages((prevFiles) => {
        if (prevFiles.length < 5) {
          return [...prevFiles, file];
        }
        return prevFiles;
      });
      const fileReader = new FileReader();
      fileReader.onload = (e) => {
        setMedia((prevMedia) => [...prevMedia, e.target.result]);
      };
      fileReader.readAsDataURL(file);
    }
  };

  // Handle file removal (optional)
  const removeImage = (index) => {
    setImages((prevImages) => prevImages.filter((_, i) => i !== index));
  };
  return (
    <div className="items-center overflow-x-hidden justify-center w-screen h-screen">
      <AppBar key="6" />
      <div className="h-10" />
      <Header />
      <div className="h-10"></div>
      <div className="flex flex-col">
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="flex flex-col items-center justify-center"
        >
          <div className="flex flex-col w-2/6">
            <SelectInput
              options={subCategories.map((e) => ({ label: e.name, value: e.id }))}
              value={getValues().subCategory_id}
              onChange={(value) => reset({ ...getValues(), subCategory_id: value })}
              // placeholder="المحصول"
              placeholder={t("addform.placeholders.crop")}
            />
          </div>
          <div className="h-5" />

          <div className="flex flex-col-reverse lg:flex-row lg:gap-5 w-full justify-center items-center">
            {/* <div className="flex flex-col w-2/6 lg:w-1/6">
              <SelectInput
                options={cities.map((e) => ({ label: e.name, value: e.id }))}
                value={getValues().city}
                onChange={(value) => reset({ ...getValues(), city: value })}
                placeholder="المدينة"
                isDisabled={cities.length === 0}
              />
            </div> */}

            <div className="h-5" />

            <div className="flex flex-col w-2/6 lg:w-1/6">
              <SelectInput
                options={states.map((e) => ({ label: e.name, value: e.id }))}
                value={getValues().state}
                onChange={(value) => {
                  setValue("state", value);
                  citiesRefetch();
                  marketRefetch();
                  localityRefetch();
                }}
                // placeholder="الولاية"
                placeholder={t("addform.placeholders.state")}
              />
            </div>
          </div>
          <div className="h-5" />

          <div className="flex flex-col lg:flex-row lg:gap-5 w-full justify-center items-center">
            <div className="flex flex-col w-2/6 lg:w-1/6">
              <SelectInput
                options={markets.map((e) => ({ label: e.name, value: e.id }))}
                value={getValues().market}
                onChange={(value) => reset({ ...getValues(), market: value })}
                // placeholder="السوق"
                placeholder={t("addform.placeholders.market")}
                isDisabled={markets.length === 0}
              />
            </div>

            <div className="h-5" />

            <div className="flex flex-col w-2/6 lg:w-1/6">
              <SelectInput
                options={locality.map((e) => ({ label: e.name, value: e.id }))}
                value={getValues().locality}
                onChange={(value) => reset({ ...getValues(), locality: value })}
                // placeholder="المحلية"
                placeholder={t("addform.placeholders.locality")}
                isDisabled={locality.length === 0}
              />
            </div>
          </div>

          <div className="h-5" />

          <div className="relative ">
            <span className="absolute  -right-3 text-xl text-red-500">*</span>
            <input
              {...register("offer", { required: true })}
              className="border-[1px] h-32 p-3 mb-5 rounded-md w-96 border-primary placeholder:font-bold placeholder:text-base  "
              multiple
              // placeholder="الوصف، مثلا (بصل صغير الحبة عالي الجودة)"
              placeholder={t("addform.placeholders.description")}
              dir="rtl"
            />
          </div>
          {/* <input {...register("location")} className="border-2 h-12 p-3 mb-5 rounded-md w-96" placeholder='الموقع' /> */}
          <div className="flex flex-col-reverse lg:flex-row lg:gap-5 w-full justify-center items-center">
            <div className="flex flex-col w-2/6 lg:w-1/6">
              <SelectInput
                options={units?.map((e) => ({ label: e.name, value: e.id }))}
                value={getValues().unit}
                onChange={(value) => reset({ ...getValues(), unit: value })}
                // placeholder="الوحدة"
                placeholder={t("addform.placeholders.unit")}
                isDisabled={units?.length === 0}
              />
            </div>
            <div className="relative">
              <span className="absolute  -right-3 text-xl text-red-500">*</span>
              <input
                type="number"
                min="1"
                {...register("quantity", {
                  valueAsNumber: true,
                  validate: (value) => value > 0,
                })}
                className="border-[1px] h-10 p-3 rounded-md w-52 border-primary placeholder:font-bold placeholder:text-base"
                // placeholder="الكمية"
                placeholder={t("addform.placeholders.quantity")}
                dir="rtl"
              />
            </div>
          </div>

          <div className="h-5" />
          {getValues().unit && (
            <div className="flex flex-row-reverse gap-6 justify-center z-[100]">
              <input
                type="number"
                min="1"
                {...register("price_per_unit", {
                  valueAsNumber: true,
                  validate: (value) => value > 0 || null,
                })}
                className="border-[1px] h-10 p-3 rounded-md w-52 border-primary text-sm placeholder:text-sm"
                placeholder={`السعر لل${getValues().unit?.label.toString() || ""
                  } الواحد`}
                dir="rtl"
              />

              <SelectInput
                options={[
                  { label: t("addform.placeholders.currency_sdg"), value: "SDG" },
                  { label: t("addform.placeholders.currency_usd"), value: "USD" },
                ]}
                onChange={(value) => reset({ ...getValues(), currency: value.value })}
                placeholder={t("addform.placeholders.currency")}
              />
            </div>
          )}
          <div className="h-5" />
          {type === "sell" && (
            <>
              < div className="w-96 h-[20vh] border-primary border-[1px] bg-gray-50 rounded-md flex justify-center items-center text-gray-500">
                <input
                  type="file"
                  id="file"
                  className="hidden"
                  onChange={(e) => handleImageUpload(e.target.files[0])}
                  accept="image/*" // Allow only image files
                />
                <label
                  htmlFor="file"
                  className="font-bold  before:mr-1 before:text-red-500"
                >
                  {/* إرفق صورة أو فيديو */}
                  {t("common.attach_media")}
                </label>
              </div>
              <div className="h-5" />

              <div className="flex flex-row gap-3">
                {media.length > 0 &&
                  media.map((src, index) => (
                    <div key={index} className="relative">
                      <img
                        src={src}
                        className="w-16 h-16 object-cover border border-gray-300 rounded"
                        alt="Preview"
                      />
                      <button
                        type="button"
                        className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center"
                        onClick={() => removeImage(index)}
                      >
                        ×
                      </button>
                    </div>
                  ))}
              </div>
            </>
          )}


          <button
            hidden={!isEdit}
            type="button"
            {...register("status")}
            className="border-2 h-12 p-3 mb-5 rounded-md w-60 bg-amber-600 text-white font-bold text-lg"
            value="تم البيع؟"
            onClick={() => sold()}
          >
            {/* تم البيع؟ */}
            {t("common.sold_button")}
          </button>

          <input
            type="submit"
            className="h-12 bg-primary text-white rounded-md w-60"
            // value={isEdit ? "تعديل" : "إضافة"}
            value={isEdit ? t("common.edit") : t("common.add")}
          />
        </form>
      </div >
      <Footer />
    </div >
  );
}

export default Addform;
